import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useLandingTranslations } from '../contexts/LandingTranslationContext';
import AnimatedLogo from './AnimatedLogo';
import ContactPopup from './ContactPopup';

const Hero = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { translations } = useLandingTranslations();

  return (
    <motion.div
      className="flex flex-col items-center justify-center min-h-[90vh] text-center relative px-4"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1.5 }}
    >
      <motion.div
        className="w-full max-w-[800px] mb-16"
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <AnimatedLogo />
      </motion.div>
      <motion.h1
        className="text-5xl font-bold text-[#3D587D] mb-4"
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ 
          duration: 1,
          ease: [0.25, 0.1, 0.25, 1]
        }}
      >
        {translations.hero.title}
      </motion.h1>
      <motion.p
        className="text-lg text-[#407CBD] max-w-3xl"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.2 }}
      >
        {translations.hero.subtitle}
      </motion.p>
      <motion.button
        className="mt-6 px-8 py-3 bg-[#FFDB89] text-[#3D587D] rounded-full shadow-lg font-semibold"
        whileHover={{ 
          scale: 1.05,
          boxShadow: "0 10px 30px rgba(61, 88, 125, 0.2)"
        }}
        whileTap={{ scale: 0.95 }}
        transition={{ type: "spring", stiffness: 400, damping: 10 }}
        onClick={() => setIsPopupOpen(true)}
      >
        {translations.hero.cta}
      </motion.button>

      <ContactPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </motion.div>
  );
};

export default Hero; 